import axios from 'axios';
import globalData from '../../config/global_variables';

const baseUrl =  globalData.MEMBERSHIP_ENGINE_URL;
const authToken = () => {
  try {
    return JSON.parse(localStorage.userData || '{}').token || '';
  } catch {
    return '';
  }
};

const authKey="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiZmlyc3RfbmFtZSI6IlJvc2huaSIsImxhc3RfbmFtZSI6IlJvc2giLCJlbWFpbCI6InJvc2huaUBnbWFpbC5jb20iLCJwYXNzd29yZCI6IjI1ZDU1YWQyODNhYTQwMGFmNDY0Yzc2ZDcxM2MwN2FkIiwiYWNjZXNzIjoiQUxMIiwic3RhdHVzIjp0cnVlLCJjcmVhdGVkX2F0IjoiMjAyNi0wOC0xMVQxMjo0Mjo0MC4wMDBaIiwidXBkYXRlZF9hdCI6IjIwMjYtMDgtMTFUMTI6NDI6NDAuMDAwWiIsImlhdCI6MTc4OTEyMjUzNSwiZXhwIjoxNzg5MjA4OTM1fQ.RXz5WO6DozuTE46RYe41ikbiddNGrk4hM3Sa6XFAng0"
const headers = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${authKey}`,
});

export const fetchMembershipRules = async (params = {}) => {
  const res = await axios.get(`${baseUrl}/api/v1/rules/listing`, {
    headers: headers(),
    params,
  });
  return res?.data?.data || res?.data || [];
};

// export const staticData =() [
//   {
//     rule_id: '1',
//     rule_name: 'Birthday Gold 7',
//     rule_description: '#1007 - by suraj',
//     benefit_mechanic: 'prive',
//     mechanic: 'Discount + Gift',
//     area: 'BAU',
//     redemption_limit_type: 'per_customer',
//     redemption_limit: 1,
//     storefront: 'DE',
//     priority: 1,
//     status: 'Active',
//     active_window_start_date: '2025-12-28',
//     active_window_end_date: '2025-12-28',    
//     created_at: '2025-12-28',
//     updated_at: '2025-12-28',
//   },
//   {
//     rule_id: '2',
//     rule_name: 'Black Friday Discount 12',
//     rule_description: '#1012 - by admin',
//     benefit_mechanic: 'Member',
//     mechanic: 'Discount',
//     area: 'Lifecycle Triggered',
//     redemption_limit_type: 'per_customer',
//     redemption_limit: 1,
//     storefront: 'UK',
//     priority: 4,
//     status: 'Draft',
//     active_window_start_date: '2025-12-28',
//     active_window_end_date: '2025-12-28',   
//     created_at: '2025-12-28',
//     updated_at: '2025-12-28',
//   },
//   {
//     rule_id: '3',
//     rule_name: 'Welcome Gift 3',
//     rule_description: '#1003 - by priya.k',
//     benefit_mechanic: 'prive',
//     mechanic: 'Gift',
//     area: 'BAU',
//     redemption_limit_type: 'per_customer',
//     redemption_limit: 1,
//     storefront: 'DE',
//     priority: 8,
//     status: 'Archived',
//     active_window_start_date: '2025-12-28',
//     active_window_end_date: '2025-12-28',    
//     created_at: '2025-12-28',
//     updated_at: '2025-12-28',
//   },
//   {
//     rule_id: '4',
//     rule_name: 'VIP Spactive_window_end_date Bonus 21',
//     rule_description: '#1021 - by rahul.m',
//     benefit_mechanic: 'prive',
//     mechanic: 'Discount + Gift',
//     area: 'Lifecycle Triggered',
//     redemption_limit_type: 'per_customer',
//     redemption_limit: 1,
//     storefront: 'UK',
//     priority: 2,
//     status: 'Paused',
//     active_window_start_date: '2025-12-28',
//     active_window_end_date: '2025-12-28',    
//     created_at: '2025-12-28',
//     updated_at: '2025-12-28',
//   },
//   {
//     rule_id: '5',
//     rule_name: 'Cart Abandon Recovery 9',
//     rule_description: '#1009 - by suraj',
//     benefit_mechanic: 'Member',
//     mechanic: 'Discount + Gift',
//     area: 'Lifecycle Triggered',
//     redemption_limit_type: 'per_customer',
//     redemption_limit: 1,
//     storefront: 'US',
//     priority: 3,
//     status: 'Draft',
//     active_window_start_date: '2025-12-28',
//     active_window_end_date: '2025-12-28',   
//     created_at: '2025-12-28',
//     updated_at: '2025-12-28',
//   },
//   {
//     rule_id: '6',
//     rule_name: 'First Purchase GWP 15',
//     rule_description: '#1015 - by admin',
//     benefit_mechanic: 'Member',
//     mechanic: 'Gift',
//     area: 'BAU',
//     redemption_limit_type: 'per_customer',
//     redemption_limit: 1,
//     storefront: 'DE',
//     priority: 5,
//     status: 'Active',
//     active_window_start_date: '2025-12-28',
//     active_window_end_date: '2025-12-28',   
//     created_at: '2025-12-28',
//     updated_at: '2025-12-28',
//   },
//   {
//     rule_id: '7',
//     rule_name: 'VIP Spactive_window_end_date Bonus 21',
//     rule_description: '#1021 - by rahul.m',
//     benefit_mechanic: 'prive',
//     mechanic: 'Discount + Gift',
//     area: 'Lifecycle Triggered',
//     redemption_limit_type: 'per_customer',
//     redemption_limit: 1,
//     storefront: 'UK',
//     priority: 2,
//     status: 'Paused',
//     active_window_start_date: '2025-12-28',
//     active_window_end_date: '2025-12-28',    
//     created_at: '2025-12-28',
//     updated_at: '2025-12-28',
//   },
//   {
//     rule_id: '8',
//     rule_name: 'VIP Spactive_window_end_date Bonus 21',
//     rule_description: '#1021 - by rahul.m',
//     benefit_mechanic: 'prive',
//     mechanic: 'Discount + Gift',
//     area: 'Lifecycle Triggered',
//     storefront: 'UK',
//     priority: 2,
//     status: 'Paused',
//     active_window_start_date: '2025-12-28',
//     active_window_end_date: '2025-12-28',   
//     created_at: '2025-12-28',
//     updated_at: '2025-12-28',
//   },
//   {
//     rule_id: '9',
//     rule_name: 'Black Friday Discount 12',
//     rule_description: '#1012 - by admin',
//     benefit_mechanic: 'Member',
//     mechanic: 'Discount',
//     area: 'Lifecycle Triggered',
//     storefront: 'UK',
//     priority: 4,
//     status: 'Draft',
//     active_window_start_date: '2025-12-28',
//     active_window_end_date: '2025-12-28',   
//     created_at: '2025-12-28',
//     updated_at: '2025-12-28',
//   },
//   {
//     rule_id: '10',
//     rule_name: 'First Purchase GWP 15',
//     rule_description: '#1015 - by admin',
//     benefit_mechanic: 'Member',
//     mechanic: 'Gift',
//     area: 'BAU',
//     storefront: 'DE',
//     priority: 5,
//     status: 'Active',
//     active_window_start_date: '2025-12-28',
//     active_window_end_date: '2025-12-28',    
//     created_at: '2025-12-28',
//     updated_at: '2025-12-28',
//   },
// ];

export const mapRuleToTableRow = (item) => ({
  key: item.rule_id,
  ruleId: item.rule_id,
  ruleName: item.rule_name,
  description: item.rule_description,
  customerGroup: item.customer_group || item.benefit_type || 'Member',
  mechanic: item.mechanic || item.benefit_mechanic || 'Discount',
  area: item.area,
  store: item.storefront || item.store || 'US',
  priority: item.priority,
  status: item.status,
  start: item.active_window_start_date,
  end: item.active_window_end_date,
  uses: item.redemption_limit || 0,
  updated: item.updated_at || item.created_at,
});

export default mapRuleToTableRow;
